import { Suspense, type ReactNode } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ProtectedRoute } from '@/auth/ProtectedRoute';
import { AppLayout } from '@/layout/AppLayout';
import DashboardPage from '@/pages/DashboardPage';
import { moduleRegistry } from '@/modules/registry';

function FullScreenSpinner(): ReactNode {
  const { t } = useTranslation();
  return (
    <div className="flex h-full items-center justify-center p-8 text-sm text-slate-500">
      {t('common.loading')}
    </div>
  );
}

export function App(): ReactNode {
  return (
    <Routes>
      <Route
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />

        {moduleRegistry.map((m) => (
          <Route
            key={m.id}
            path={`${m.path}/*`}
            element={
              <ProtectedRoute requireModule={m.id} requireAnyRole={m.requiredRoles}>
                <Suspense fallback={<FullScreenSpinner />}>
                  <m.Component />
                </Suspense>
              </ProtectedRoute>
            }
          />
        ))}

        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
